module.exports = __webpack_public_path__ + "img/projetos.e346b137.jpg";